<template>
    <v-container v-if="!can('studentStatistics')" fluid class="pa-0 statistics-view">
        <plan-required-content inline feature="studentStatistics" />
    </v-container>
    <v-container v-else fluid class="pa-0 statistics-view">
        <div class="statistics-tabbar">
            <select-option-students underline no-grow :custom-options="sections" :value="currentSection" @change="onClickMenu" />
        </div>

        <statistics-form with-last-weeks :isCompetence="isCompetence"
            @load="onLoadDocs" @loadLastWeeks="lastWeeks = $event" @loading="loading = $event"
            @reset="onReset" @change:date:start="date = $event" @change:date:end="endDate = $event" />

        <div class="statistics-body pa-3">
            <template v-if="currentSection === 'statistics'">
                <skeleton-loader v-if="loading" type="stat-grid" />
                <div v-else-if="docs.length > 0" class="stats-grid">
                    <acute-chronic-chart :docs="lastWeeks" />
                    <last-weeks-chart :docs="lastWeeks" />
                    <sessions-chart :docs="docs" :date="date" />
                    <exercises-chart :docs="docs" :coach-id="coachId" />
                    <variables-chart :docs="docs" />
                    <wellness-chart :docs="docs" />
                </div>
            </template>
            <template v-else-if="isCompetence">
                <skeleton-loader v-if="loading" type="stat-grid" />
                <statistics-competences v-else-if="docs.length > 0" :docs="docs" :start-date="date" :end-date="endDate" />
            </template>

            <div v-if="searched && !loading && docs.length === 0" class="stats-empty">
                <v-icon size="46" color="txtMuted">mdi-chart-box-outline</v-icon>
                <p>{{ $t('statistics.no_data') }}</p>
            </div>
        </div>
    </v-container>
</template>

<script>

import StatisticsForm from "@/components/statistics/StatisticsForm";
import WellnessChart from "@/components/statistics/WellnessChart";
import SessionsChart from '../../components/statistics/SessionsChart.vue';
import VariablesChart from '../../components/statistics/VariablesChart.vue';
import LastWeeksChart from '../../components/statistics/LastWeeksChart.vue';
import ExercisesChart from '../../components/statistics/ExercisesChart.vue';
import AcuteChronicChart from '../../components/statistics/AcuteChronicChart.vue';
import StatisticsCompetences from '../../components/statistics/StatisticsCompetences.vue';
import SelectOptionStudents from '../../components/coach/SelectOptionStudents.vue';
import SkeletonLoader from '@/components/common/SkeletonLoader'
import PlanRequiredContent from '@/components/common/PlanRequiredContent'

export default {
    components: { WellnessChart, StatisticsForm, SessionsChart, VariablesChart, LastWeeksChart, ExercisesChart, AcuteChronicChart, StatisticsCompetences, SelectOptionStudents, SkeletonLoader, PlanRequiredContent },
    data() {
        return {
            docs: [],
            date: null,
            endDate: null,
            lastWeeks: [],
            currentSection: 'statistics',
            loading: false,
            searched: false,
        }
    },
    computed: {
        coachId(vm = this) {
            return vm.account?.studentSubscription?.coachId || null
        },
        sections(vm = this) {
            return [
                { name: vm.$t('common.statistics'), value: 'statistics' },
                { name: vm.$t('common.competences'), value: 'competence' },
            ]
        },
        isCompetence(vm = this) {
            return vm.currentSection === 'competence'
        },
    },
    methods: {
        onLoadDocs(docs) {
            const vm = this
            vm.docs = docs
            vm.searched = true
        },
        onReset() {
            const vm = this
            vm.docs = []
            vm.lastWeeks = []
            vm.searched = false
        },
        onClickMenu(section) {
            const vm = this
            vm.currentSection = section
            vm.docs = []
            vm.lastWeeks = []
            vm.searched = false
        },
    }
}
</script>

<style scoped>
.statistics-tabbar {
    padding: 0 24px;
    border-top: 1px solid var(--v-outline-base);
    border-bottom: 1px solid var(--v-outline-base);
    overflow-x: auto;
}

.statistics-tabbar ::v-deep .view-tab:first-child {
    padding-left: 0;
}

.statistics-body {
    min-height: 0;
}

.stats-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 72px 16px;
    text-align: center;
    color: var(--v-txtMuted-base);
}

.stats-empty p {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: minmax(340px, auto);
    gap: 14px;
}

@media (max-width: 1100px) {
    .stats-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 760px) {
    .statistics-tabbar {
        padding: 0 8px;
    }
}

@media (max-width: 700px) {
    .stats-grid {
        grid-template-columns: 1fr;
    }
}
</style>
